module.exports = __webpack_public_path__ + "assets/media/extension-browser-image.f33dae6e.png";